import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../../Header/header";
import {
    Box,
    Typography,
    TextField,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    Select,
    MenuItem,
    IconButton,
    Chip,
    InputAdornment,
    CircularProgress,
    Pagination,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchIcon from "@mui/icons-material/Search";
import SideBar from "./TeacherSidebar/TeacherSidebar";
import { useNavigate } from "react-router-dom";
import { API_LoginURL } from "../../../config";

const ProjectsTable = () => {
    const [projectsData, setProjectsData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filter, setFilter] = useState("All");
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 5;
    const navigate = useNavigate();

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const response = await axios.get(
                    `${API_LoginURL}project/ProjectSubmissionListById`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: localStorage.getItem("token"),
                        },
                    }
                );
                setProjectsData(response.data);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching submitted projects:", error);
                setLoading(false);
            }
        };

        fetchProjects();
    }, []);

    // Filter projects based on search term and status filter
    const filteredProjects = projectsData.filter((project) => {
        const matchesSearch =
            project.projectName
                ?.toLowerCase()
                .includes(searchTerm.toLowerCase()) ||
            project.userName?.toLowerCase().includes(searchTerm.toLowerCase());

        const matchesFilter = filter === "All" || project.status === filter;

        return matchesSearch && matchesFilter;
    });

    // Pagination logic
    const totalPages = Math.ceil(filteredProjects.length / rowsPerPage);
    const currentRows = filteredProjects.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleFilterChange = (event) => {
        setFilter(event.target.value);
        setCurrentPage(1); // Reset to first page when filter changes
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // Reset to first page when search changes
    };

    return (
        <div className="container-scroller">
            <Navbar />
            <div className="container-fluid page-body-wrapper">
                <SideBar />
                <div className="main-panel">
                    <Box
                        sx={{
                            height: "calc(100vh - 60px)",
                            padding: "20px",
                            backgroundColor: "#F8F9FD",
                            overflowY: "scroll",
                        }}
                    >
                        <div className="card">
                            <div className="card-body">
                                <Box p={3}>
                                    <Typography
                                        variant="h5"
                                        fontWeight="bold"
                                        mb={2}
                                    >
                                        Projects
                                    </Typography>

                                    {/* Search & Filter */}
                                    <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        mb={2}
                                        gap={2}
                                        flexWrap="wrap"
                                    >
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            placeholder="Search by project or user..."
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                            sx={{ flexGrow: 1, maxWidth: 400 }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />

                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            gap={1}
                                        >
                                            <Typography variant="body1">
                                                Filter:
                                            </Typography>
                                            <Select
                                                size="small"
                                                value={filter}
                                                onChange={handleFilterChange}
                                            >
                                                <MenuItem value="All">
                                                    All
                                                </MenuItem>
                                                <MenuItem value="Approved">
                                                    Approved
                                                </MenuItem>
                                                <MenuItem value="Pending">
                                                    Pending
                                                </MenuItem>
                                                <MenuItem value="Rejected">
                                                    Rejected
                                                </MenuItem>
                                            </Select>
                                        </Box>
                                    </Box>

                                    {loading ? (
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            p={5}
                                        >
                                            <CircularProgress />
                                        </Box>
                                    ) : (
                                        <>
                                            <TableContainer component={Paper}>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>
                                                                S.No
                                                            </TableCell>
                                                            <TableCell>
                                                                Project name
                                                            </TableCell>
                                                            <TableCell>
                                                                Grade
                                                            </TableCell>
                                                            <TableCell>
                                                                User name
                                                            </TableCell>
                                                            <TableCell>
                                                                Status
                                                            </TableCell>
                                                            <TableCell>
                                                                Date
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                View Projects
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {currentRows.length >
                                                        0 ? (
                                                            currentRows.map(
                                                                (
                                                                    project,
                                                                    index
                                                                ) => (
                                                                    <TableRow
                                                                        key={
                                                                            project.projectSubmissionId
                                                                        }
                                                                        sx={{
                                                                            bgcolor:
                                                                                project.status ===
                                                                                "Approved"
                                                                                    ? "#f3fdf6"
                                                                                    : "#fff5f5",
                                                                        }}
                                                                    >
                                                                        <TableCell>
                                                                            {(currentPage -
                                                                                1) *
                                                                                rowsPerPage +
                                                                                index +
                                                                                1}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            <Typography
                                                                                color="primary"
                                                                                sx={{
                                                                                    cursor: "pointer",
                                                                                }}
                                                                            >
                                                                                {
                                                                                    project.projectName
                                                                                }
                                                                            </Typography>
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            <Chip
                                                                                label={
                                                                                    project.className ||
                                                                                    "-"
                                                                                }
                                                                                variant="outlined"
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {
                                                                                project.userName
                                                                            }
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {
                                                                                project.status
                                                                            }
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {project.projectSubmissionDate ||
                                                                                "-"}
                                                                        </TableCell>
                                                                        <TableCell align="center">
                                                                            <IconButton
                                                                                color="primary"
                                                                                onClick={() => {
                                                                                    sessionStorage.setItem(
                                                                                        "teacherProjectApprovalId",
                                                                                        project.projectSubmissionId
                                                                                    );
                                                                                    navigate(
                                                                                        "/TeacherprojectInfo"
                                                                                    );
                                                                                }}
                                                                                disabled={
                                                                                    project.status ===
                                                                                    "Approved"
                                                                                }
                                                                            >
                                                                                <VisibilityIcon />
                                                                            </IconButton>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            )
                                                        ) : (
                                                            <TableRow>
                                                                <TableCell
                                                                    colSpan={7}
                                                                    align="center"
                                                                >
                                                                    No projects
                                                                    found
                                                                    matching
                                                                    your
                                                                    criteria
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                            {filteredProjects.length >
                                                rowsPerPage && (
                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    mt={3}
                                                >
                                                    <Pagination
                                                        count={totalPages}
                                                        page={currentPage}
                                                        onChange={
                                                            handlePageChange
                                                        }
                                                        color="primary"
                                                        shape="rounded"
                                                    />
                                                </Box>
                                            )}
                                        </>
                                    )}
                                </Box>
                            </div>
                        </div>
                    </Box>
                </div>
            </div>
        </div>
    );
};

export default ProjectsTable;
